module.exports = __webpack_public_path__ + "img/wechat-qrcode.80fe829e.jpg";